// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8waNw","title":"styles_title__9r0kQ"};